export const SUBMIT_CHECKLIST_ACTION_REQUESTED =
  "SUBMIT_CHECKLIST_ACTION_REQUESTED";
export const SUBMIT_CHECKLIST_ACTION_DISPATCHER =
  "SUBMIT_CHECKLIST_ACTION_DISPATCHER";
export const SUBMIT_CHECKLIST_ERROR_DISPATCHER =
  "SUBMIT_CHECKLIST_ERROR_DISPATCHER";
export const CHECKLIST_LOADING = "CHECKLIST_LOADING";
export const SUBMIT_CHECKLIST_DOWNLOAD_PDF_ACTION_REQUESTED="SUBMIT_CHECKLIST_DOWNLOAD_PDF_ACTION_REQUESTED";
export const CHECKLIST_DOWNLOAD_PDF_ACTION_REQUESTED="CHECKLIST_DOWNLOAD_PDF_ACTION_REQUESTED";
export const SUBMIT_CHECKLIST_DOWNLOAD_EXCEL_ACTION_REQUESTED="SUBMIT_CHECKLIST_DOWNLOAD_EXCEL_ACTION_REQUESTED";
export const CHECKLIST_DOWNLOAD_EXCEL_ACTION_REQUESTED="CHECKLIST_DOWNLOAD_EXCEL_ACTION_REQUESTED";
//Action Creator
export const submitChecklistAction = (data) => ({
  type: SUBMIT_CHECKLIST_ACTION_REQUESTED,
  postData: data,
});

//Action Dispatcher
export const submitChecklistActionDispatcher = (data) => ({
  type: SUBMIT_CHECKLIST_ACTION_DISPATCHER,
  payload: data,
});

export const submitChecklistErrorDispatcher = (data) => ({
  type: SUBMIT_CHECKLIST_ERROR_DISPATCHER,
  payload: data,
});

export const ChecklistLoading = (loading) => ({
  type: CHECKLIST_LOADING,
  payload: loading,
});


export const submitChecklistDownloadPdfAction = (data) => ({
  type: SUBMIT_CHECKLIST_DOWNLOAD_PDF_ACTION_REQUESTED,
  postData: data,
});

export const checklistDownloadPdfActionDispatcher = (data) => ({
  type: CHECKLIST_DOWNLOAD_PDF_ACTION_REQUESTED,
  postData: data,
});
export const submitChecklistDownloadExcelAction = (data) => ({
  type: SUBMIT_CHECKLIST_DOWNLOAD_EXCEL_ACTION_REQUESTED,
  postData: data,
});

export const checklistDownloadExcelActionDispatcher = (data) => ({
  type: CHECKLIST_DOWNLOAD_EXCEL_ACTION_REQUESTED,
  postData: data,
});